import React, { Component } from 'react';
import '../styling/Footer.css';

export default class Footer extends Component {
  render() {
    return (
      <div className='footer'>
          <p>"So much universe, and so little time"
              ― Terry Pratchett.</p>
      </div>
    )
  }
}
